import React, { useEffect } from 'react';
import { Switch, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import AuthRoute from '../utils/AuthRoute';
import OpenRoute from '../utils/OpenRoute';

import SignIn from '../features/user/SignIn';
import HomePage from '../pages/HomePage';

import { setCurrentPage } from '../features/layout/layoutSlice';

const Routes = () => {
    const dispatch = useDispatch();
    let location = useLocation();

    useEffect(
        () => {
            dispatch(setCurrentPage(location.pathname));
        },
        [location, dispatch]
    )

    return (
        <Switch>
            <OpenRoute exact path="/" component={SignIn} />
            <AuthRoute path="/secured" component={HomePage} />
        </Switch>
    );
}

export default Routes;
